import React, { useState, useEffect, useRef } from "react";
import Header from "../../component/menu/Header";
import { constants } from "../../constant/constants";
import SideMenu from "../../component/menu/SideMenu";
import RefundsReportComponent from "../../component/restaurants/reports/ReundsReportComponent";
import { ReportService } from "../../services/reports-services";
import useUserStore from "../../stores/store";
import CustomLoader from "../../component/menu/CustomLoader";

export default function RefundReport() {
  const { user, restaurantId, showNotification, networkCall, setNetworkCall } = useUserStore();
  const [refundSummary, setRefundSummary] = useState({});
  const [refundReportList, setRefundReportList] = useState(null);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalItem, setTotalItem] = useState(0);
  const [refundFilter, setRefundFilter] = useState({
    restaurantId: restaurantId,
    orderNo: "",
    mobileNo: "",
    fromDate: "",
    toDate: "",
    status: "",
  });
  const [isFilterClear, setIsFilterClear] = useState(false);
  const isFetching = useRef(false);
  // const [isLoading, setIsLoading] = useState(false);

  async function fetchRefundReportList(filter) {
    setNetworkCall(true);
    try {
      const refundList = await ReportService.getRefundCancelReportList(
        filter,
        user.token.token
      );
      setRefundReportList(ReportService.formatDataList(refundList.data));
      setPage(refundList.page);
      setPerPage(refundList.perPage);
      setTotalItem(refundList.total);
      setNetworkCall(false);
    } catch (err) {
      showNotification("Something went wrong in serverside. Try again later.");
      setNetworkCall(false);
      return;
    }
  }

  /** init **/
  useEffect(() => {
    async function fetchSummaryReport() {
      try {
        const summaryReport = await ReportService.getRefundReportSummary(
          restaurantId,
          user.token.token
        );
        setRefundSummary(summaryReport.data);
      } catch (error) {
        console.error("Error fetching report:", error);
        showNotification("Something went wrong. Try again later.");
        return;
      }
    }

    fetchSummaryReport();

  }, [restaurantId]);

  useEffect(() => {
    async function fetchData() {
      if (isFetching.current) return;
      isFetching.current = true;

      try {
        const tempFilter = { ...refundFilter, page, perPage };
        await fetchRefundReportList(tempFilter);
      } catch (err) {
        console.error("Error fetching:", err);
      } finally {
        isFetching.current = false;
      }
    }

    fetchData();
  }, [page, perPage]);

  useEffect(() => {
    async function fetchData() {
      if (isFilterClear) {
        await fetchRefundReportList(refundFilter);
        setIsFilterClear(false);
      }
    }

    fetchData();
  }, [isFilterClear]);

  function onHandleFilterData() {
    if (page !== 1 || perPage !== 10) {
      setPage(1);
      setPerPage(10);
    }
    const tempFilter = { ...refundFilter, page: 1, perPage: 10 };
    fetchRefundReportList(tempFilter);
  }

  function onHandlePageChange(page, pageSize) {
    setPage(page);
    setPerPage(pageSize);
  }

  function onHandlePageSizeChange(current, size) {
    setPerPage(size);
  }

  function onHandleDownloadReport() {
    const { page, perPage, ...params } = refundFilter;
    setNetworkCall(true);
    ReportService.getDownloadRefundsAndCancellationReport(params, user.token.token).then(
      (res) => {
        if (res.data) {
          setNetworkCall(false);
          ReportService.downloadPDF(res.data, "refunds-and-cancellation-report.pdf");
          showNotification("Refunds and Cancellation report downloaded successfully!", false);
        } else {
          setNetworkCall(false);
          showNotification("Failed to download the report");
          return;
        }
      }
    );
  }

  return (
    <section>
      <div className="flex flex-col">
        <CustomLoader />
        <Header title={""} menu={""} currentMenuKey={'T_6_S_6_L_3'} />
        <div className="flex flex-row bg-prewhite px-[12%]">
          <SideMenu title={`Sale Report`} menu={constants.MENU.REPORTS[3]} />
        </div>
        <div className=" mt-[80px] ml-[80px] px-[50px]">
          <h1 className="pt-[50px] pb-[20px] font-bold text-black text-[24px] leading-[24px] cursor-default">
            {constants.MENU.REPORTS[3] + " & Cancellations Report"}
          </h1>

          <RefundsReportComponent
            summaryData={refundSummary}
            reportData={refundReportList}
            setRefundFilter={setRefundFilter}
            handleFilterApply={onHandleFilterData}
            page={page}
            perPage={perPage}
            setPerPage={setPerPage}
            total={totalItem}
            handlePageChange={onHandlePageChange}
            handlePageSizeChange={onHandlePageSizeChange}
            setIsFilterClear={setIsFilterClear}
            handleDownload={onHandleDownloadReport}
            loading={networkCall}
          />
        </div>
      </div>
    </section>
  );
}
